module.exports = __webpack_public_path__ + "img/arrow-left-right.dd9548d7.svg";